import React, { useState, useEffect, useRef } from 'react'
import { gsap } from 'gsap'
import { useReveal } from '../hooks/useAnimations'

export default function Header() {
  const [scrolled, setScrolled] = useState(false)
  const [menuOpen, setMenuOpen] = useState(false)
  const headerRef = useRef<HTMLElement>(null)

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40)
    window.addEventListener('scroll', onScroll, { passive: true })
    return () => window.removeEventListener('scroll', onScroll)
  }, [])

  useEffect(() => {
    if (!headerRef.current) return
    const ctx = gsap.context(() => {
      gsap.fromTo(
        headerRef.current,
        { opacity: 0, y: -20 },
        { opacity: 1, y: 0, duration: 1, ease: 'power3.out' }
      )
    }, headerRef.current)
    return () => ctx.revert()
  }, [])

  const navItems = [
    { label: 'Services', href: '#services' },
    { label: 'Maison', href: '#maison' },
    { label: 'Experience', href: '#experience' },
    { label: 'Reservations', href: '#reservations' },
  ]

  return (
    <header
      ref={headerRef}
      className={`header ${scrolled ? 'header--scrolled' : ''} ${menuOpen ? 'header--menu-open' : ''}`}
    >
      <div className="header__inner">
        <a href="#top" className="header__logo">
          <span className="header__logo-mark">A</span>
          <span className="header__logo-text">Aure Studio</span>
        </a>

        <nav className="header__nav" aria-label="Primary">
          {navItems.map((item) => (
            <a key={item.href} href={item.href} className="header__link">
              {item.label}
            </a>
          ))}
        </nav>

        <div className="header__actions">
          <a href="#reservations" className="header__cta">
            Book Now
          </a>
          <button
            className="header__burger"
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label="Toggle menu"
            aria-expanded={menuOpen}
          >
            <span className="header__burger-line" />
            <span className="header__burger-line" />
            <span className="header__burger-line" />
          </button>
        </div>
      </div>

      <div className="header__mobile-menu">
        {navItems.map((item) => (
          <a key={item.href} href={item.href} className="header__mobile-link" onClick={() => setMenuOpen(false)}>
            {item.label}
          </a>
        ))}
      </div>
    </header>
  )
}